import { Roles } from "constants/roles";
import axiosInstance from "./config";

const basePath = `/auth`;

export const loginInduk = (data: { email: string; password: string }) => {
  return axiosInstance.post(`${basePath}/admin/induk/login`, data);
};

export const getProfile = () => {
  return axiosInstance.get(`/profile`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  });
};

export const refreshToken = () => {
  return axiosInstance.get(`${basePath}/refresh-token`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("refresh_token")}`,
    },
  });
};

export const logoutAccount = () => {
  return axiosInstance.get(`${basePath}/logout`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  });
};

export const getUsers = (search?: string, role?: Roles, page?: number) => {
  return axiosInstance.get(`/induk-app/users`, {
    params: {
      search,
      role,
      page,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    },
  });
};
